import { ADD, SET, GET, CLEAR, UPDATE, CLIP } from '../constants';

export const add = (data) => ({
  type: ADD,
  data,
});

export const set = (data) => ({
  type: SET,
  data,
});

export const get = () => ({
  type: GET,
});

export const clear = () => ({
  type: CLEAR,
});

export const update = (data) => ({
  type: UPDATE,
  data,
});

export const clip = (data) => ({
  type: CLIP,
  data,
});
